import axios from "@/lib/axios";

const getCustomers = () => {
  return axios.get("/facility/facility_agreements/customers");
}

export default getCustomers;